export default __webpack_public_path__ + "static/media/infrastructure-fund-card-banner.e8e6122a.png";